// Centralisation de l'UID du Super-Administrateur créateur
export const SUPER_ADMIN_UID = 'jQqFRA5eyvYhCSJu1McKeRWD8o72';
// export const ADMIN_UID = 'LjE5j8ZQAYUltPfGEgY5Pfw7oNh2';

// 🚀 LISTE GLOBALE DES UID ADMINS EN DUR (Sécurité absolue)
// export const ADMIN_LIST = [SUPER_ADMIN_UID, ADMIN_UID];

// La liste de secours ne contient que ton profil
export const ADMIN_LIST = [SUPER_ADMIN_UID];